// src/client.ts
import { feathers } from "@feathersjs/feathers";
import authenticationClient from "@feathersjs/authentication-client";

// src/services/visit/visit.shared.ts
var visitPath = "/booking/v1/:tenantId/visit";
var visitMethods = ["find", "get", "pendingVisitsForUser"];
var visitClient = (client) => {
  const connection = client.get("connection");
  client.use(visitPath, connection.service(visitPath), {
    methods: visitMethods
  });
};

// src/services/booking/booking.shared.ts
var bookingPath = "/booking/v1/:tenantId";
var bookingMethods = ["create", "update", "checkin", "checkout", "createHideVIPBooking"];
var createBookingClient = (client) => {
  const connection = client.get("connection");
  client.use(bookingPath, connection.service(bookingPath), {
    methods: bookingMethods
  });
};

// src/services/visit-user-type/visitUserType.shared.ts
var visitUserTypePath = "/booking/v1/:tenantId/visit-user-type";
var visitUserTypeMethods = ["find", "get", "create", "patch", "remove"];
var visitUserTypeClient = (client) => {
  const connection = client.get("connection");
  client.use(visitUserTypePath, connection.service(visitUserTypePath), {
    methods: visitUserTypeMethods
  });
};

// src/services/visit-user-field/visit-user-field.shared.ts
var visitUserFieldPath = "/booking/v1/:tenantId/visit-user-field";
var visitUserFieldMethods = ["find", "get"];
var visitUserFieldClient = (client) => {
  const connection = client.get("connection");
  client.use(visitUserFieldPath, connection.service(visitUserFieldPath), {
    methods: visitUserFieldMethods
  });
};

// src/services/validate/validate.shared.ts
var validatePath = "/booking/v1/:tenantId/validate";
var validateMethods = ["validateVisitors", "create"];
var validateClient = (client) => {
  const connection = client.get("connection");
  client.use(validatePath, connection.service(validatePath), {
    methods: validateMethods
  });
};

// src/services/visit-user/visitUser.shared.ts
var visitUserPath = "/booking/v1/:tenantId/visit-user";
var visitUserMethods = ["find", "get", "create", "patch", "remove"];
var visitUserClient = (client) => {
  const connection = client.get("connection");
  client.use(visitUserPath, connection.service(visitUserPath), {
    methods: visitUserMethods
  });
};

// src/client.ts
var createClient = (connection, authenticationOptions = {}) => {
  const client = feathers();
  client.configure(connection);
  client.configure(authenticationClient(authenticationOptions));
  client.set("connection", connection);
  client.configure(validateClient);
  client.configure(visitUserTypeClient);
  client.configure(createBookingClient);
  client.configure(visitClient);
  client.configure(visitUserFieldClient);
  client.configure(visitUserClient);
  return client;
};
export {
  createClient
};
//# sourceMappingURL=client.js.map